import type { ReactElement } from "react";
import cx from "classnames";
import Button from "../../atoms/Button";
import Text from "../../atoms/Text";
import * as s from "./styles";

export interface CallToAction {
  action: () => void;
  label: string;
}

interface Props {
  callToAction?: CallToAction;
  icon?: ReactElement;
  children?: ReactElement;
  message?: string;
  size?: "md" | "sm";
  variant?: "dark" | "light";
}

export default function Notice({
  callToAction,
  icon,
  children,
  message,
  size = "md",
  variant = "light",
}: Props): ReactElement {
  const getWrapperClassName = () => {
    if (variant === "dark") {
      return size === "md" ? s.wrapperDark : s.wrapperDarkSm;
    }
    return size === "md" ? s.wrapper : s.wrapperSm;
  };

  return (
    <div className={getWrapperClassName()}>
      <div className={s.content}>
        {icon && (
          <div
            className={cx(
              variant === "dark" ? "text-status-info-300" : "text-neutral-600",
            )}
          >
            {icon}
          </div>
        )}
        {message && (
          <Text
            color={variant === "dark" ? "light" : "secondary"}
            size={size === "md" ? "base" : "sm"}
            weight="medium"
          >
            {message}
          </Text>
        )}
        {children}
        {typeof callToAction !== "undefined" && (
          <div key={callToAction.label}>
            <Button onClick={callToAction.action} variant="link">
              {callToAction.label}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
